import installer from "./defaults";
export * from "@xplus/components";
export * from "@xplus/hooks";

export { default as makeInstaller } from "./make-installer";
export { default } from "./defaults";

export const install = installer.install;
export const version = installer.version;
